import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../../../../../utils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';

function RiskAnalysis() {
    const [checkedValue, setCheckedValue] = useState({ risk_analysis: '' });
    const [updatedTask, setUpdatedTask] = useState(null);
    const uid = localStorage.getItem("user_id");

    const fetchData = async () => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);

            const response = await axios.post(`${API.BASE_URL}${API.ENDPOINTS.get_growth_risk}`, formDataToSend, {
                headers: {
                    Authorization: `${API.AUTHORIZATION_TOKEN}`,
                },
            });

            if (response.data.status === "success") {
                setCheckedValue(response.data.data || { risk_analysis: '' });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error('Fetch technology data error', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const debouncedUpdateTask = useCallback(
        debounce(async (task) => {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', uid);
            formDataToSend.append('analysis', task.value || '');

            try {
                const response = await axios.post(
                    `${API.BASE_URL}${API.ENDPOINTS.add_update_risk_analysis}`,
                    formDataToSend,
                    {
                        headers: {
                            Authorization: `${API.AUTHORIZATION_TOKEN}`,
                        },
                    }
                );

                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    fetchData();
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error("An error occurred while updating data.");
            }
        }, 1000),
        [uid]
    );

    useEffect(() => {
        if (updatedTask) {
            debouncedUpdateTask(updatedTask);
        }
    }, [updatedTask, debouncedUpdateTask]);

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        // Update the state based on the checkbox value
        setCheckedValue({
            risk_analysis: checked ? value : ''
        });

        // Set the updated task to trigger debounced update
        setUpdatedTask({
            value: checked ? value : ''
        });
    };

    return (
        <div className="col-sm-12">
            <div className="card mt-4">
                <div className="card-header">
                    <div className='justify-content-between d-flex '>
                        <div className="">
                            <h5>Risk Analysis</h5>

                        </div>
                        <div >
                            <Link className='backto-ondriver' to="/growthframeworks/founderdriver">Back to the Founder OS Drivers of Growth</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="card-body">
                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.risk_analysis === 'Enterprise' ? '#d3f9d8' : 'white' }} // Light greenish color
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Enterprise"
                                    checked={checkedValue.risk_analysis === 'Enterprise'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Enterprise</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Functions work together to deliver efficient and effective enterprise-wide risk management. This results in a lower cost of capital, high stakeholder confidence and trust, competitive advantage and improved business performance.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.risk_analysis === 'Corporation' ? '#d3f9d8' : 'white' }} // Light greenish color
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Corporation"
                                    checked={checkedValue.risk_analysis === 'Corporation'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Corporation</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • There are formal roles and functions to address risks. Typically, these operate independently.
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div
                            className="founderdriers mb-3"
                            style={{ backgroundColor: checkedValue.risk_analysis === 'Startup' ? '#d3f9d8' : 'white' }} // Light greenish color
                        >
                            <label><b>
                                <input
                                    className="checkbox_animated"
                                    type="checkbox"
                                    value="Startup"
                                    checked={checkedValue.risk_analysis === 'Startup'}
                                    onChange={handleCheckboxChange}
                                />
                                <strong>Maturity Level: Startup</strong>
                            </b></label>
                            <ul>
                                <li>
                                    <p className="textnots-text">
                                        • Management fully understands key risks and shares responsibility for them.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default RiskAnalysis;
